import { cn } from '@/lib/cn';

export function Section({
  label,
  tone,
  children,
}: {
  label: string;
  tone: 'neutral' | 'running' | 'success' | 'failure';
  children: React.ReactNode;
}) {
  const dotColor = {
    neutral: 'bg-muted-foreground/60',
    running: 'bg-blue-400',
    success: 'bg-emerald-400',
    failure: 'bg-red-400',
  }[tone];
  return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-1.5">
        <span className={cn('h-1.5 w-1.5 rounded-full', dotColor)} />
        <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          {label}
        </span>
      </div>
      {children}
    </div>
  );
}
